import { List } from 'immutable';
import Availability from 'MeetingsBase/models/Availability';
import TimeRange from 'MeetingsBase/models/TimeRange';
import AvailableTimeChunk from 'MeetingsBase/models/AvailableTimeChunk';
import { AVAILABILITY_OPTIONS } from 'MeetingsBase/constants/dates';
export function getChunkListFromRecord(availability) {
  const chunks = [];
  const keys = Object.keys(AVAILABILITY_OPTIONS);
  for (const day of keys) {
    const timeRanges = availability[day] || [];
    for (const timeRange of timeRanges) {
      chunks.push(new AvailableTimeChunk({
        day,
        startMinute: timeRange.start,
        endMinute: timeRange.end
      }));
    }
  }
  return List(chunks);
}
export function getRecordFromChunkList(availableTimeChunks) {
  const result = {};
  availableTimeChunks.forEach(timeChunk => {
    const day = timeChunk.day;
    if (!result[day]) {
      result[day] = [];
    }
    result[day].push(TimeRange.from({
      start: timeChunk.startMinute,
      end: timeChunk.endMinute
    }));
  });
  return new Availability(result);
}